function openSecondaryMenu() {
  const menuBtn = document.querySelector(".js-products");
  const secMenu = document.querySelector(".c-main-menu__secondary");

  if (!menuBtn || !secMenu) {
    return;
  }

  function openMenu(e) {
    e.preventDefault();
    menuBtn.classList.toggle("active");
    secMenu.classList.toggle("active");

    if (menuBtn.classList.contains("active")) {
      document.addEventListener("click", documentClick);
    } else {
      document.removeEventListener("click", documentClick);
    }
  }

  menuBtn.addEventListener("click", openMenu);

  function documentClick(e) {
    if (
      !e.target.closest(".c-main-menu__secondary") &&
      !e.target.closest(".js-products")
    ) {
      openMenu(e);
    }
  }
}

export { openSecondaryMenu };

function openLanguagesMenu() {
  const menuBtn = document.querySelector(".js-languages");

  if (!menuBtn) {
    return;
  }

  const secMenu = document.querySelector(".c-main-menu__languages");

  function openMenu(e) {
    e.preventDefault();
    menuBtn.classList.toggle("active");
    secMenu.classList.toggle("active");

    if (menuBtn.classList.contains("active")) {
      document.addEventListener("click", documentClick);
    } else {
      document.removeEventListener("click", documentClick);
    }
  }

  menuBtn.addEventListener("click", openMenu);

  function documentClick(e) {
    if (
      !e.target.closest(".c-main-menu__languages") &&
      !e.target.closest(".js-languages")
    ) {
      openMenu(e);
    }
  }
}

export { openLanguagesMenu };

function openSupportMenu() {
  function initSupportMenu() {
    const menuBtn = document.querySelector(".js-support");
    const secMenu = document.querySelector(".c-main-menu__support");

    function openMenu(e) {
      e.preventDefault();
      menuBtn.classList.toggle("active");
      secMenu.classList.toggle("active");

      if (menuBtn.classList.contains("active")) {
        document.addEventListener("click", documentClick);
      } else {
        document.removeEventListener("click", documentClick);
      }
    }

    menuBtn.addEventListener("click", openMenu);

    function documentClick(e) {
      if (
        !e.target.closest(".c-main-menu__support") &&
        !e.target.closest(".js-support")
      ) {
        openMenu(e);
      }
    }
  }

  const isPresent = document.getElementsByClassName("js-support");
  if (isPresent.length > 0) {
    initSupportMenu();
  }
}

export { openSupportMenu };

function openMobileSupportMenu() {
  // function initMobileSupportMenu() {
  //   const menuBtn = document.querySelector(".js-mobile-support");
  //   const secMenu = document.querySelector(".c-mobile-menu__support");

  //   function openMenu(e) {
  //     e.preventDefault();
  //     menuBtn.classList.toggle("active");
  //     secMenu.classList.toggle("active");

  //     if (menuBtn.classList.contains("active")) {
  //       document.addEventListener("click", documentClick);
  //     } else {
  //       document.removeEventListener("click", documentClick);
  //     }
  //   }

  //   menuBtn.addEventListener("click", openMenu);

  //   function documentClick(e) {
  //     if (
  //       !e.target.closest(".c-mobile-menu__support") &&
  //       !e.target.closest(".js-mobile-support")
  //     ) {
  //       openMenu(e);
  //     }
  //   }
  // }

  // const isPresent = document.getElementsByClassName("js-mobile-support");
  // if (isPresent.length > 0) {
  //   initMobileSupportMenu();
  // }

  function animateInMaxHeight(element) {
    function removeMaxHeight() {
      this.style.maxHeight = "none";
      this.removeEventListener("transitionend", transitionEndCallback);
      delete element._transitionEnd;
    }

    let transitionEndCallback = removeMaxHeight.bind(element);
    element._transitionEnd = transitionEndCallback;

    element.style.maxHeight = `${element.scrollHeight}px`;
    element.addEventListener("transitionend", transitionEndCallback);
  }

  function animateOutMaxHeight(element) {
    element.style.maxHeight = `${element.scrollHeight}px`;
    element.offsetHeight;

    if (element._transitionEnd) {
      element.removeEventListener("transitionend", element._transitionEnd);
    }

    setTimeout(function () {
      element.style.maxHeight = "0px";
    }, 1);
  }

  function animateToggle() {
    const toggleTriggers = document.querySelectorAll(`.js-mobile-support`);
    toggleTriggers.forEach((trigger) => {
      // let toggle = document.querySelector(
      //   `[aria-labelledby=${trigger.getAttribute("id")}]`
      // );

      let toggle = trigger.nextElementSibling;

      if (toggle.classList.contains("hidden")) {
        toggle.style.maxHeight = `0px`;
        toggle.classList.remove("hidden");
      }
      toggle.classList.add("overflow-hidden");
      toggle.style.transition = `max-height 400ms`;

      function openItem() {
        //toggle.classList.remove('hidden')
        trigger.setAttribute("aria-expanded", "true");
        //toggle.classList.add('visible')
        animateInMaxHeight(toggle);
      }

      function closeItem() {
        //toggle.classList.add('hidden')
        trigger.setAttribute("aria-expanded", "false");
        //toggle.classList.remove('visible')

        animateOutMaxHeight(toggle);
      }

      trigger.addEventListener(
        "click",
        (e) => {
          e.preventDefault();

          if (trigger.getAttribute("aria-expanded") === "false") {
            openItem();
          } else {
            closeItem();
          }
        },
        false
      );
    });
  }

  animateToggle();
}

export { openMobileSupportMenu };

function openMobileMenu() {
  const hamburger = document.querySelector(".js-main-menu-burger");
  const menu = document.querySelector(".c-mobile-nav");

  if (!hamburger || !menu) {
    return;
  }
  // const menuItems = document.querySelectorAll('.c-mobile-nav__inner a')

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
    menu.classList.toggle("c-mobile-nav--open");
  });

  // menuItems.forEach(menuItem => {
  //   menuItem.addEventListener('click', () => {
  //     hamburger.classList.toggle('is-active')
  //     menu.classList.toggle('c-mobile-nav--open')
  //   })
  // })
}

export { openMobileMenu };

function openProductsMobileMenu() {
  function triggerProductsMenu() {
    const hamburger = document.querySelector(".js-product-menu-burger");
    const menu = document.querySelector(".c-product-mobile-nav");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("c-product-mobile-nav--open");
    });
  }

  const isPresent = document.getElementsByClassName("js-product-menu-burger");
  if (isPresent.length > 0) {
    triggerProductsMenu();
  }
}

export { openProductsMobileMenu };
